export default {
  name: "device model capability",
  plural: "device model capabilities",
  columns: {
    capability: "capability",
    capabilityId: "capability ID",
    deviceModelVersion: "device model version",
    deviceModelVersionId: "device model version ID",
    fieldSelector: "field selector",
    id: "ID",
    isDeleted: "is deleted",
    technicalMax: "technical Max",
    technicalMin: "technical Min",
    tenantId: "tenant ID",
    unit: "unit",
    unitId: "unit ID",
  },
};
